<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TopoMain',
})
</script>
<template>
<div class="flex align-start">
<div class="topo-main flex1" v-if="configData">
    <vue-ruler-tool :parent="true" :is-scale-revise="true" style="width:100%;height: calc(100% - 40px);">
        <div
            tabindex="0"
            id="surface-edit-layer"
            class="topo-layer"
            :class="{'topo-layer-view-selected': selectedIsLayer}"
            :style="layerStyle"
            @click="onLayerClick($event)"
            @mouseup="onLayerMouseup($event)"
            @mousemove="onLayerMousemove($event)"
            @mousedown="onLayerMousedown($event)"
            @keyup.delete="removeItem"
            @dragover.prevent
            @drop="onDrop"
            @keydown.ctrl.67.stop="copyItem"
            @keydown.ctrl.86.stop="pasteItem"
            @keydown.ctrl.90.stop="undo"
            @keydown.ctrl.89.stop="redo">

                <div v-for="(component,index) in configData.components"
                     :key="index"
                     tabindex="0"
                     class="topo-layer-view"
                     :class="hasComponent(component)?'topo-layer-view-selected':''"
                     @click.stop="clickComponent(index,component,$event)"
                     @mousedown.stop="controlMousedown(component,$event,index)"

                     @keydown.up.exact.prevent="moveItems('up')"
                     @keydown.right.exact.prevent="moveItems('right')"
                     @keydown.down.exact.prevent="moveItems('down')"
                     @keydown.left.exact.prevent="moveItems('left')"
                     :style="{
                            left: component.style.position.x + 'px',
                            top: component.style.position.y + 'px',
                            width: component.style.position.w + 'px',
                            height: component.style.position.h + 'px',
                            'background-color': component.style.backColor,
                            zIndex: component.style.zIndex,
                            borderWidth: component.style.borderWidth + 'px',
                            borderStyle: component.style.borderStyle,
                            borderColor: component.style.borderColor,
                            transform: component.style.transform? `rotate(${component.style.transform}deg)`:'rotate(0deg)',
                        }">
                    <component :is="parseView(component)" :detail="component" :editMode="true" :ref="'comp'+index" :selected="hasComponent(component)"/>
                    <template v-if="hasComponent(component)">
                      <div @mousedown.stop="resizeMousedown(component,$event,index,'resize-lt')" class="resize-left-top"></div>
                      <div @mousedown.stop="resizeMousedown(component,$event,index,'resize-lc')"  class="resize-left-center"></div>
                      <div @mousedown.stop="resizeMousedown(component,$event,index,'resize-lb')"  class="resize-left-bottom"></div>
                      <div @mousedown.stop="resizeMousedown(component,$event,index,'resize-rt')" class="resize-right-top"></div>
                      <div @mousedown.stop="resizeMousedown(component,$event,index,'resize-rc')"  class="resize-right-center"></div>
                      <div @mousedown.stop="resizeMousedown(component,$event,index,'resize-rb')"  class="resize-right-bottom"></div>
                      <div @mousedown.stop="resizeMousedown(component,$event,index,'resize-ct')"  class="resize-center-top"></div>
                      <div @mousedown.stop="resizeMousedown(component,$event,index,'resize-cb')"  class="resize-center-bottom"></div>
                    </template>
                </div>
            <div  class="topo-frame-selection" :style="{width: frameSelectionDiv.width + 'px',height: frameSelectionDiv.height + 'px',top: frameSelectionDiv.top + 'px',left: frameSelectionDiv.left + 'px'}">
            </div>
        </div>
    </vue-ruler-tool>
    <div style="height: 40px;border-top: #ccc solid 1px;position:relative;background-color:white;">
        <div style="position:absolute;left: 0px;top: 0px;" class="flex align-center">
            <div style="line-height:40px;height:40px;">
                已选组件个数：{{selectedComponents.length}}
            </div>
            <a-button label="预览" style="margin-left:100px;height:30px;margin-top:5px;" @click="fullScreen">预览</a-button>

            <a-button label="当前数据"   style="margin-left:100px;height:30px;margin-top:5px;" @click="printData" >当前数据</a-button>
        </div>
        <div  style="position:absolute;right: 10px;top: 0px;" class="flex align-center flex1">
            <div style="line-height:40px;height:40px;padding: 0px 5px;">
                缩放
            </div>
            <a-slider
                v-model:value="selectedValue"
                :min="30"
                :max="200"
                :step="1"
                style="width:200px;"
                ></a-slider>
        </div>
    </div>
</div>
<div class="padding-lr" style=" width: 300px;height:100%;overflow-y: auto;overflow-x: hidden;box-sizing: border-box;">
  <TopoDataEdit  v-if="selectedIsLayer" v-model:data="configData"></TopoDataEdit>
  <template v-else>
    <TopoComponetEdit v-if="selectedComponents.length>0" v-model:component="selectedComponents[0]" ></TopoComponetEdit>
  </template>

</div>
</div>
</template>

<script setup lang="ts" name="TopoMain">
import VueRulerTool from './ruler.vue';

import topoUtil from './util/topo-util.js';
import { deepCopy} from "@/assets/libs/utils.js";
import {v4} from 'uuid'

import { checkInRange,checkByPointInRect,checkByRectCollisionDetection} from "@/assets/libs/topo";
import {ref,computed,onMounted,getCurrentInstance,nextTick,watch,withDefaults,defineEmits,defineProps} from 'vue'
import {useRouter} from 'vue-router'
import { topoData } from '@/store/topo-editor/getters';
import { Component } from '@logicflow/core';
import TopoComponetEdit from '@/components/Topo/topo/TopoComponetEdit.vue';
import TopoDataEdit from '@/components/Topo/topo/TopoDataEdit.vue';

//关键变量----------------
const configData=ref<object>(null)
const selectedComponents=ref<Array>([]) //选中的组件
const deleteComponents=ref<Array>([]) //只有在回退的时候用
const selectedIsLayer=ref<boolean>(true)
var copySrcItems=[]
var copyCount=0
var redoStack=[]
var undoStack=[]
//-----------------------
const router=useRouter()
const instance=getCurrentInstance()
//移动组件 相关变量
const moveItem=ref({
                startX: 0,
                startY: 0
            })

var  resizeItem= {
                startPx: 0,
                startPy: 0,
                x: 0,
                y: 0,
                w: 0,
                h: 0,
            }, //resize组件 相关变量
            flag= '', //当前操作标志位
            curControl= null,
            curIndex= -1 ;
const frameSelectionDiv=ref<Object>({
                width: 0,
                height: 0,
                top: 10,
                left: 10,
                startX: 0,
                startY: 0,
                startPageX: 0,
                startPageY: 0,
            })
const selectedValue=ref<Number>(100);
function hasComponent(component:any){
  return  selectedComponents.value.findIndex(e=>{return e.identifier==component.identifier})>-1
}
function emit(){

}
function setSelectedComponent(component:Any){
  if (!component.identifier) {
    component.identifier = v4();
  }
  selectedComponents.value=[component]
  emit()
}
function addSelectedComponent(component:Any){
  if (!component.identifier) {
    component.identifier = v4();
  }
  if(selectedComponents.value.findIndex(e=>{return e.identifier==component.identifier})<0){
      selectedComponents.value.push(component)
  }
  emit()
}
function removeSelectedComponent(component:Any){
 if (!component.identifier) return;
   var index=selectedComponents.value.findIndex(e=>{return e.identifier==component.identifier})
   if(index>-1){
    selectedComponents.value.splice(index,1)
   }
   emit()
}
function clearSelectedComponent(){
  selectedComponents.value = []
  setLayerSelected.value=true
  emit()
}
function setLayerSelected(s:Boolean){
  selectedIsLayer.value = s;
  emit()
}
function setCopySrcItems(data:Object){
  copySrcItems = data;
  copyCount = 0;
}
function increaseCopyCount(){
  copyCount++;
}
function execute(command:Any){
  //暂时不做参数校验
  //在这里分发命令--这里暂时先用switch分发，应该用表格分发
  var fuid = v4();
  switch (command.op) {
    case "add":
      var component = command.component;
      component.identifier = fuid;
      component.name = component.type + configData.value.components.length;
      component.style.visible = true;
      component.style.transform = 0;
      component.style.borderWidth = component.style.borderWidth
        ? component.style.borderWidth
        : 0;
      component.style.borderStyle = component.style.borderStyle
        ? component.style.borderStyle
        : "solid";
      component.style.borderColor = component.style.borderColor
        ? component.style.borderColor
        : "#ccccccff";
      configData.value.components.push(component);

      break;
    case "del":
      var keys = selectedComponents.value.map(e=>e.identifier);
      var filtered=configData.value.components.filter(e=>{return !keys.includes(e.identifier)})
      configData.value.components=filtered
      selectedComponents.value.forEach(e => {
          deleteComponents.value.push(e)
      });
      command.components=deepCopy(selectedComponents.value)
      selectedComponents.value=[]
      break;
    case "move":
      var dx = command.dx,
        dy = command.dy;
      for (var key in command.items) {
        var component = command.items[key];
        component.style.position.x = component.style.position.x + dx;
        component.style.position.y = component.style.position.y + dy;
      }
      break;
    case "copy-add":
      debugger;
      clearSelectedComponent()
      for (let i = 0; i < command.items.length; i++) {
        var t = command.items[i];
        var component = deepCopy(t);
        component.identifier = fuid;
        component.name = component.type + configData.value.components.length;
        component.style.visible = true;
        //这里应该根据选中的的组件确定位置-暂时用个数
        component.style.position.x =
          component.style.position.x + 25 * (copyCount + 1);
        component.style.position.y =
          component.style.position.y + 25 * (copyCount + 1);
        configData.value.components.push(component);
        addSelectedComponent(component)
        increaseCopyCount()
      }
      break;
    default:
      console.warn("不支持的命令.");
      break;
  }
  undoStack.push(command)
}
function undo(){
  var command = undoStack.pop();
  if (command == undefined) {
    return;
  }
  switch (command.op) {
    case "add":
      var component = command.component;
      //逆向循环删除
      var index=configData.value.components.findIndex(e=>{return e.identifier==component.identifier})
      if(index>-1){
        configData.value.components.splice(index, 1);
      }
      break;
    case "del":
       if(command.components){
        command.components.forEach(element => {
          configData.value.components.push(element)
        });
       }
      break;
    case "move":
      var dx = command.dx,
        dy = command.dy;
      for (var key in selectedComponentMap.value) {
        var component = selectedComponentMap.value[key];
        component.style.position.x = component.style.position.x - dx;
        component.style.position.y = component.style.position.y - dy;
      }
      break;
    case "copy-add":
      console.log("undo暂不支持：copy-add");
      break;
    default:
      break;
  }
  redoStack.push(command);
}
function redo(){
  var command = redoStack.pop();
  if (command == undefined) {
    console.log("none redo command.");
    return;
  }
  execute(command)
}
//加载数据，现在用不上
function loadDefaultTopoData(){
  configData.value={
      name:'图层',
      layer:{backColor:'#f8f8f8',height:800,width:1200,widthHeightRatio:''},components:[]
    }
  emit()
}



const layerStyle=computed(()=>{
  console.info('更新回来的数据',configData.value)
            var scale = selectedValue.value / 100;
            var styles = [`transform:scale(${scale})`];
            if(configData.value.layer.backColor) {
                styles.push(`background-color: ${configData.value.layer.backColor}`);
            }
            if(configData.value.layer.backgroundImage) {
                styles.push(`background-image: url("${configData.value.layer.backgroundImage}")`);
            }
            if(configData.value.layer.width > 0) {
                styles.push(`width: ${configData.value.layer.width}px`);
            }
            if(configData.value.layer.height > 0) {
                styles.push(`height: ${configData.value.layer.height}px`);
            }
            var style = styles.join(';');
            return style;
 })

function controlMousedown(component,event,index) {
            if(event.ctrlKey) {
                return;
            }
            flag = 'move';
            curControl = component;
            clickItem(component,index);
            moveItem.value.startX = event.pageX;
            moveItem.value.startY = event.pageY;
            //记录初始信息--move
            selectedComponents.value.forEach(component => {
                component.style.temp = {};
                component.style.temp.position = {};
                component.style.temp.position.x = component.style.position.x;
                component.style.temp.position.y = component.style.position.y;
            })
        }
function  resizeMousedown(component,$event,index,fg) {//resize-鼠标按下事件
            flag = fg;
            curControl = component;
            curIndex = index;
             clickItem(component,index);
            var dom = event.currentTarget;
            resizeItem.startPx = event.pageX;
            resizeItem.startPy = event.pageY;
            //记录初始信息-resize
            resizeItem.x = curControl.style.position.x;
            resizeItem.y = curControl.style.position.y;
            resizeItem.w = curControl.style.position.w;
            resizeItem.h = curControl.style.position.h;
        }
function  onLayerMousemove(event) {
            if(event.which != 1) {
                flag = '';
                return;
            }
            if (flag == '')
                return;

            if(flag.startsWith('resize')) {
                var dx = event.pageX - resizeItem.startPx,
                    dy = event.pageY - resizeItem.startPy;
                switch (flag) {
                    case 'resize-lt':
                        curControl.style.position.x = resizeItem.x + dx;
                        curControl.style.position.y = resizeItem.y + dy;
                        dx = -dx;
                        dy = -dy;
                        break;
                    case 'resize-lc':
                        curControl.style.position.x = resizeItem.x + dx;
                        dy = 0;
                        dx = -dx;
                        break;
                    case 'resize-lb':
                        curControl.style.position.x = resizeItem.x + dx;
                        dx = -dx;
                        break;
                    case 'resize-rt':
                        curControl.style.position.y = resizeItem.y + dy;
                        dy = -dy;
                        break;
                    case 'resize-rc':
                        dy = 0;
                        break;
                    case 'resize-rb':
                        break;
                    case 'resize-ct':
                        curControl.style.position.y = resizeItem.y + dy;
                        dx = 0;
                        dy = -dy;
                        break;
                    case 'resize-cb':
                        dx = 0;
                        break;
                }
                if((resizeItem.w + dx) > 20) {
                    curControl.style.position.w = resizeItem.w + dx;
                }
                if((resizeItem.h + dy) > 20) {
                    curControl.style.position.h = resizeItem.h + dy;
                }
                //canvas组件需要重新渲染
                // DOM 还没有更新
                nextTick(()=>{
                  var refs=instance.refs
                    var a =  refs['comp' + curIndex];
                    if(a){
                        a[0].onResize();
                    }
                })
            } else if(flag ==  'move') {
                //移动组件
                var dx = event.pageX - moveItem.value.startX,
                    dy = event.pageY - moveItem.value.startY;
                selectedComponents.value.forEach(component => {
                    component.style.position.x = component.style.temp.position.x + dx;
                    component.style.position.y = component.style.temp.position.y + dy;
                });
            } else if(flag == 'frame_selection') {
                onFrameSelection(event);
            }
        }
function  onLayerMouseup(event) {
            if(flag.startsWith('resize')) {
                var refs= instance.refs
                var a = refs['comp' + curIndex][0];
                a.onResize();
            } else if(flag == 'frame_selection') {
                //由于和onLayerClick冲突，这里模拟下点击空白区域
                onFrameSelection(event);
                frameSelectionDiv.value.width = 0;
                frameSelectionDiv.value.height = 0;
                frameSelectionDiv.value.top = 0;
                frameSelectionDiv.value.left = 0;

            } else if(flag == 'move') {
                //鼠标move只是方便用户预览，真正执行应该用命令，所以要先恢复
                var dx = event.pageX - moveItem.value.startX;
                var dy = event.pageY - moveItem.value.startY;
                selectedComponents.value.forEach(component => {
                  component.style.position.x = component.style.position.x - dx;
                  component.style.position.y = component.style.position.y - dy;
                });

                execute({
                    op: 'move',
                    dx: dx,
                    dy: dy,
                    items: selectedComponents.value
                });
            }
            flag = '';
        }
function  onLayerMousedown($event) {
            flag = 'frame_selection';
            clearSelectedComponent();
            frameSelectionDiv.value.startX = event.offsetX;
            frameSelectionDiv.value.startY = event.offsetY;
            frameSelectionDiv.value.startPageX = event.pageX;
            frameSelectionDiv.value.startPageY = event.pageY;
        }
function  onLayerClick() {
             //clearSelectedComponent();
             //setLayerSelected(true);
        }
function  onFrameSelection(event){
            var dx = event.pageX - frameSelectionDiv.value.startPageX;
            var dy = event.pageY - frameSelectionDiv.value.startPageY;
            frameSelectionDiv.value.width = Math.abs(dx);
            frameSelectionDiv.value.height = Math.abs(dy);
            if(dx > 0 && dy > 0) {
                frameSelectionDiv.value.top = frameSelectionDiv.value.startY;
                frameSelectionDiv.value.left = frameSelectionDiv.value.startX;
            } else if(dx > 0 && dy < 0) {
                frameSelectionDiv.value.top = frameSelectionDiv.value.startY + dy;
                frameSelectionDiv.value.left = frameSelectionDiv.value.startX;
            } else if(dx < 0 && dy > 0) {
                frameSelectionDiv.value.top = frameSelectionDiv.value.startY;
                frameSelectionDiv.value.left = frameSelectionDiv.value.startX + dx;
            } else if(dx < 0 && dy < 0) {
                frameSelectionDiv.value.top = frameSelectionDiv.value.startY + dy;
                frameSelectionDiv.value.left = frameSelectionDiv.value.startX + dx;
            }
            //判断各个组件是否在方框内
            var rect = {
                x: frameSelectionDiv.value.left,
                y: frameSelectionDiv.value.top,
                width: frameSelectionDiv.value.width,
                height: frameSelectionDiv.value.height
            };
            var components = configData.value.components;
            var inRectComponents= components.filter(component=>{
                var itemRect = {
                    x: component.style.position.x,
                    y: component.style.position.y,
                    width: component.style.position.w,
                    height: component.style.position.h,
                }
                return checkByRectCollisionDetection(rect,itemRect)
            })
            if(inRectComponents.length>0){
                selectedComponents.value=inRectComponents
                setLayerSelected(false);
            } else {
                setLayerSelected(true);
            }
        }
function  onDrop(event) {
            event.preventDefault();
            var infoJson = event.dataTransfer.getData('my-info');
            var component = JSON.parse(infoJson);
            if(checkAddComponent(component) == false) {
                return;
            }
            if(!component.identifier){
              component.identifier=v4()
            }
            //判断当前着陆点是不是layer
            if(event.target.id == "surface-edit-layer") {
                component.style.position.x = event.offsetX;
                component.style.position.y = event.offsetY;
            } else {
                //解决着陆灯不是layer的情形
                var layer = event.currentTarget;
                var position = layer.getBoundingClientRect();
                var x = event.clientX - position.left;
                var y = event.clientY - position.top;
                component.style.position.x = x;
                component.style.position.y = y;
            }
            //处理默认值
            execute({
                op: 'add',
                component: component
            });
            //默认选中，并点击
            clickItem(component,configData.value.components.length - 1);
        }
function  moveItems(direction){
            var dx = 0,dy = 0;
            if(direction == 'up') {
                dy = -5;
            } else if(direction == 'right') {
                dx = 5;
            } else if(direction == 'down') {
                dy = 5;
            } else if(direction == 'left') {
                dx = -5;
            }
            execute({
                op: 'move',
                dx: dx,
                dy: dy,
                items: selectedComponents.value
            });
        }
function  checkAddComponent(info){
            if(info == null) {
                console.error('组件未找到')
                return false;
            }
            return true;
        }
function  parseView(component) {
            return   topoUtil.parseViewName(component);
        }
function  clickItem(component, index) {
            setLayerSelected(false);
            setSelectedComponent(component);
        }
function  clickComponent(index,component,event){//点击组件
            if(event.ctrlKey == true) { //点击了ctrl

                if(selectedComponents.value.findIndex(e=>{return e.identifier==component.identifier})>-1){
                  removeSelectedComponent(component)
                }else{
                  addSelectedComponent(component);
                }
            }
            setLayerSelected(false);
        }
function  copyItem(){ // 设定复制源
            var items = [];
            selectedComponents.value.forEach(element => {
                var item = deepCopy(element);
                item.identifier=v4()
                items.push(item)
            })
            setCopySrcItems(items);
        }
function  pasteItem() {
            if(copySrcItems && copySrcItelength > 0) {
                execute({
                    op: 'copy-add',
                    items: copySrcItems,
                });
            }
        }
function  removeItem() { //移除组件
            execute({
                op: 'del'
            });
            setLayerSelected(true);
        }
function  fullScreen() {
            localStorage.setItem('topoData',JSON.stringify(configData.value));

            let {href} = router.resolve({
               path: '/topo/full'
            });
            window.open(href, '_blank');
        }
function printData(){
            var json = JSON.stringify(configData.value);
            console.log(json);
            //alert(json);
        }



onMounted(()=>{
  loadDefaultTopoData()


})

</script>

<style lang="less">
@import '@/style/main.less';
.topo-main {
    background-color: white;
    border: #ccc solid 1px;
    position: relative;
    overflow-x: hidden;
    overflow-y: hidden;
    .topo-layer {
        width: 100%;
        height: 100%;
        position: relative;
        transform-origin: left top;
        overflow: auto;
        // background-color: white;
        // background-clip: padding-box;
        // background-origin: padding-box;
        // background-repeat: no-repeat;
        // background-size: 100% 100%;

        background-image:
        linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc),
        linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc);
        background-size: 20px 20px;
        background-position: 0 0, 10px 10px;

        .topo-frame-selection {
            background-color: #8787e7;
            opacity: 0.3;
            border: #0000ff solid 1px;
            position: absolute;
            z-index: 999;
        }

        .topo-layer-view {
            position: absolute;
            height: 100px;
            width: 100px;
            background-color: #999;
            cursor: move;
            border: #ccc solid 1px;

            .resize-left-top {
                position: absolute;
                height: 10px;
                width: 10px;
                background-color: @primary;
                border: 1px solid #0cf;
                left: -5px;
                top: -5px;
                cursor: nwse-resize;
            }

            .resize-left-center {
                position: absolute;
                height: 10px;
                width: 10px;
                background-color: @primary;
                border: 1px solid #0cf;
                left: -5px;
                top: 50%;
                margin-top: -5px;
                cursor: ew-resize;
            }

            .resize-left-bottom {
                position: absolute;
                height: 10px;
                width: 10px;
                background-color: @primary;
                border: 1px solid #0cf;
                left: -5px;
                bottom: -5px;
                cursor: nesw-resize;
            }

            .resize-right-top {
                position: absolute;
                height: 10px;
                width: 10px;
                background-color:@primary;
                border: 1px solid #0cf;
                right: -5px;
                top: -5px;
                cursor: nesw-resize;
            }

            .resize-right-center {
                position: absolute;
                height: 10px;
                width: 10px;
                background-color:@primary;
                border: 1px solid #0cf;
                right: -5px;
                top: 50%;
                margin-top: -5px;
                cursor: ew-resize;
            }

            .resize-right-bottom {
                position: absolute;
                height: 10px;
                width: 10px;
                background-color:@primary;
                border: 1px solid #0cf;
                right: -5px;
                bottom: -5px;
                cursor: nwse-resize;
            }

            .resize-center-top {
                position: absolute;
                height: 10px;
                width: 10px;
                background-color: @primary;
                border: 1px solid #0cf;
                top: -5px;
                left: 50%;
                margin-left: -5px;
                cursor: ns-resize;
            }

            .resize-center-bottom {
                position: absolute;
                height: 10px;
                width: 10px;
                background-color:@primary;
                border: 1px solid #0cf;
                bottom: -5px;
                left: 50%;
                margin-left: -5px;
                cursor: ns-resize;
            }
        }

        .topo-layer-view-selected {
            outline: 1px solid @primary;
        }
    }
}
</style>
